import React from 'react';
import './CollapsibleSection.css';

const CollapsibleSection = ({ 
  title, 
  isCollapsed, 
  onToggle, 
  children,
  headerBadge = null,
}) => {
  return (
    <div className="collapsible-section">
      <div className={`collapsible-header${isCollapsed && headerBadge ? ' collapsible-header--with-badge' : ''}`} onClick={onToggle}>
        <div className="collapsible-header__title">
          <h4>{title}</h4>
        </div>
        {isCollapsed && headerBadge ? (
          <div className="collapsible-header__badge">{headerBadge}</div>
        ) : null}
        <span className="collapse-icon">{isCollapsed ? '▼' : '▲'}</span>
      </div>
      {!isCollapsed && (
        <div className="collapsible-content">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
